import { render, staticRenderFns } from "./TrimmingImageFreeHand.vue?vue&type=template&id=e0766dcc&"
import script from "./TrimmingImageFreeHand.vue?vue&type=script&lang=js&"
export * from "./TrimmingImageFreeHand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports